export default __webpack_public_path__ + "static/media/MaleHeadTop.c5d90751.png";